/* $Id$ */

require('./Editor.css')
var Cropper = require('exports-loader?Cropper!../../Cropper/cropper.js')

/**
 * A tool for making per-Image-object and per-imager-transformation
 * adjustments to images served by Foundation.
 *
 * To add edit links to every img served via imager on a page, call:
 *
 *     Foundation.Image.Editor.setupEditButtons()
 *
 * Images with an attached edit link will have the 'has-imgeditor-button'
 * class.  This permits incremental button setup and allows for special
 * styling of editable images.
 * @constructor
 * @param {string} imagerUrl
 * @param {function(Foundation.Image)} callback
 */
Foundation.Image.Editor = function (imagerUrl, callback) {
    this.image = new Foundation.Image(imagerUrl);
    this.callback = callback;

    var parts = Foundation.Image.parseImagerUrl(imagerUrl);
    this.fieldType = parts.fieldType;
    this.transformation = parts.transformation;
    this.oid = parts.oid;
    this.fileName = parts.fileName;
    this.origUrl = parts.origUrl;

    this.beginModal();

    this.finishedPromise = new Foundation.Promise();
    this.finishedPromise.then(function () {
        this.callback(this.image);
    }.bind(this))
};

/**
 * @public
 * @return {Foundation.Promise}
 */
Foundation.Image.Editor.prototype.finished = function () {
    return this.finishedPromise;
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.beginModal = function () {
    new Ajax.Request("/gyrobase/Admin/ImgEditor/ImageInfo", {
        "parameters": {
            "oid": this.oid,
            "trans": this.transformation,
            "field_type": this.fieldType,
            "path": this.fileName,
            "origUrl": this.origUrl
        },
        "onSuccess": this.finishedInfoRequest.bind(this),
        "onException": this.endModal.bind(this)
    });

    // Create modal shade div
    this.shadeElem = new Element("div")
        .addClassName("imgeditor_shade")
        .setOpacity(0)
        .observe("click", this.cancel.bind(this));
    $(document.body).insert(this.shadeElem);

    // Create the editor chrome and view
    var vdim = new Foundation.WindowDimensions();
    var voff = document.viewport.getScrollOffsets();
    this.editorChrome = new Element("div")
        .addClassName("imgeditor_chrome")
        .setOpacity(0)
        .setStyle({
            "width": "150px",
            "height": "150px",
            "left": `${Math.floor((vdim.width / 2) - 75 - 40 + voff.left)}px`,
            "top": `${Math.floor((vdim.height / 2) - 75 - 40 + voff.top)}px`
        });
    this.editorView = new Element("div")
        .addClassName("imgeditor_view");
    $(document.body).insert(this.editorChrome.insert(this.editorView));
    this.chromeColor = this.editorChrome.getStyle("backgroundColor");

    // Close button for the modal view.
    var close_button = new Element("img")
        .writeAttribute("src", "/foundation/images/icons/closebox.png")
        .addClassName("imgeditor_close")
        .observe("click", this.cancel.bind(this));
    this.editorChrome.insert(close_button);

    // Fade in the modal editing window.
    this.spinner = new Foundation.View.Spinner(this.editorChrome, { "delay": 1 });
    new Effect.Parallel([
        new Effect.Opacity(this.editorChrome, { "sync": true, "from": 0, "to": 1 }),
        new Effect.Opacity(this.shadeElem, { "sync": true, "from": 0, "to": 0.7 })
    ], {
        "duration": 0.3
    });
};

/**
 * @private
 * @param {Object=} obj
 * @param {(string|Object)=} exception
 */
Foundation.Image.Editor.prototype.endModal = function (obj, exception) {
    if (this.spinner) {
        this.spinner.hide();
        this.spinner = null;
    }

    new Effect.Parallel([
        new Effect.Opacity(this.editorChrome, { "sync": true, "to": 0 }),
        new Effect.Opacity(this.shadeElem, { "sync": true, "to": 0 })
    ], {
        "duration": 0.3,
        "afterFinish": this.cleanUp.bind(this)
    });
    if (obj && window.console) window.console.error(exception, obj);

    this.finished().tryFail();
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.cleanUp = function () {
    this.shadeElem.remove();
    this.editorChrome.remove();
    if (this.spinner) this.spinner.hide();
    if (this.cropper) this.cropper.remove();
};

/**
 * @private
 * @param {Ajax.Response} transport
 */
Foundation.Image.Editor.prototype.finishedInfoRequest = function (transport) {
    if (transport.responseJSON["status"] != "success") {
        window.alert(transport.responseJSON["msg"].replace(/\s+/g, " "));
        this.endModal();
        return;
    }

    var response = transport.responseJSON;

    /**
     * @type {string}
     */
    this.oid = response["oid"];

    /**
     * @type {string}
     */
    this.cropCoords = response["cropCoords"];

    /**
     * @type {number}
     */
    this.width = response["width"];

    /**
     * @type {number}
     */
    this.height = response["height"];

    /**
     * @type {{type:string, width:number, height:number}}
     */
    this.constraints = response["constraints"];

    this.determineDimensions();

    this.spinner.hide();
    this.spinner = null;

    if (this.cropCoords) {
        var regex = /(\d+),\s*(\d+)\s+(\d+),\s*(\d+)/;
        var coords = this.cropCoords.match(regex);
        if (!coords) throw `Bad cropCoords: ${this.cropCoords}`;
        this.origCoords = {
            "x1": parseInt(coords[1], 10), "y1": parseInt(coords[2], 10),
            "x2": parseInt(coords[3], 10), "y2": parseInt(coords[4], 10)
        };
    }

    var vdim = new Foundation.WindowDimensions();
    var voff = document.viewport.getScrollOffsets();
    new Effect.Morph(this.editorChrome, {
        "style": {
            "width": `${this.viewWidth}px`,
            "height": `${this.viewHeight}px`,
            "left": `${Math.floor((vdim.width / 2) - (this.chromeWidth / 2) + voff.left)}px`,
            "top": `${Math.floor((vdim.height / 2) - (this.chromeHeight / 2) + voff.top)}px`
        },
        "duration": 0.2,
        "afterFinish": this.setupUI.bind(this)
    });
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.determineDimensions = function () {
    var chromeMargin = 40 + 20;

    // Get the horizontal space taken up by view padding.
    var vpl = parseInt(this.editorView.getStyle("paddingLeft"), 10);
    var vpr = parseInt(this.editorView.getStyle("paddingRight"), 10);
    var hViewPadding = vpl + vpr;

    // Get the vertical space taken up by view padding.
    var vpt = parseInt(this.editorView.getStyle("paddingTop"), 10);
    var vpb = parseInt(this.editorView.getStyle("paddingBottom"), 10);
    var vViewPadding = vpt + vpb + 70;  // Plus 70px for UI.

    // Get the horizonatal space taken up by the chrome padding.
    var cpl = parseInt(this.editorChrome.getStyle("paddingLeft"), 10);
    var cpr = parseInt(this.editorChrome.getStyle("paddingRight"), 10);
    var hChromePadding = cpl + cpr;

    // Get the vertical space taken up by the chrome padding.
    var cpt = parseInt(this.editorChrome.getStyle("paddingTop"), 10);
    var cpb = parseInt(this.editorChrome.getStyle("paddingBottom"), 10);
    var vChromePadding = cpt + cpb;

    // Determine what the editorImg size should be so that we don't
    // overflow the browser window.
    var winDim = new Foundation.WindowDimensions();
    var dialogWidth = this.width + hViewPadding + hChromePadding + chromeMargin;
    var dialogHeight = this.height + vViewPadding + vChromePadding + chromeMargin;
    if (dialogWidth > winDim.width || dialogHeight > winDim.height) {
        var w = winDim.width - hViewPadding - hChromePadding - chromeMargin;
        var h = winDim.height - vViewPadding - vChromePadding - chromeMargin;

        if (this.width > this.height) {
            var h1 = this.ratioSolve(w, this.width, this.height);
            if (h1 > h) {
                w = this.ratioSolve(h, this.height, this.width);
            }
            else {
                h = h1;
            }
        }
        else {
            var w1 = this.ratioSolve(h, this.height, this.width);
            if (w1 > w) {
                h = this.ratioSolve(w, this.width, this.height);
            }
            else {
                w = w1;
            }
        }

        this.editImgDim = { "width": w, "height": h };
    }
    else {
        this.editImgDim = { "width": this.width, "height": this.height };
    }

    this.viewWidth = (this.editImgDim.width > 400 ? this.editImgDim.width : 400) + hViewPadding;
    this.viewHeight = this.editImgDim.height + vViewPadding;
    this.chromeWidth = this.viewWidth + hChromePadding;
    this.chromeHeight = this.viewHeight + vChromePadding;
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.setupUI = function () {
    // Load in the original image
    /*
    this.editImg = new Element("img", {
        "src": "/imager/"+this.fieldType+"/original/"+this.oid+"/"+this.fileName,
        "width": this.editImgDim.width,
        "height": this.editImgDim.height
    });
    */
    // David: my replacement, to have original path
    this.editImg = new Element("img", {
        "src": this.origUrl,
        "width": this.editImgDim.width,
        "height": this.editImgDim.height
    });
    this.editorView.insert(this.editImg.wrap("div", {
        "class": "imgeditor_imgwrapper",
        "style": `width:${this.editImgDim.width}px`
    }));

    // Create title element
    this.title = new Element("div")
        .addClassName("imgeditor_title")
        .insert(`Editing "${this.transformation}" Transformation`);
    this.editorChrome.insert(this.title);

    // Create placeholder for warning text
    this.warning = new Element("div").addClassName("imgeditor_warning");
    this.editorChrome.insert(this.warning);

    // Setup the cropper form
    var form = new Element("form", {
        "method": "post",
        "action": "/gyrobase/Admin/ImgEditor/ImageSave"
    })
        .observe("submit", this.save.bind(this))
        .insert(new Element("input", {
            "type": "hidden",
            "name": "oid",
            "value": this.oid
        }))
        .insert(new Element("input", {
          "type": "hidden",
          "name": "fieldType",
          "value": this.fieldType
        }))
        .insert(new Element("input", {
            "type": "hidden",
            "name": "trans",
            "value": this.transformation
        }))
        .insert(new Element("input", {
            "type": "hidden",
            "name": "x2",
            "id": "imgeditor_x2"
        }))
        .insert(new Element("input", {
            "type": "hidden",
            "name": "y2",
            "id": "imgeditor_y2"
        }))
        .insert(new Element("table")
            .insert(new Element("tr")
                .insert(new Element("td")
                    .insert(new Element("label", { "for": "imgeditor_x1" })
                        .insert("X:")
                ))
                .insert(new Element("td")
                    .insert(new Element("input", {
                        "type": "text",
                        "name": "x1",
                        "id": "imgeditor_x1",
                        "size": "4",
                        "readonly": "readonly"
                    })
                ))
                .insert(new Element("td")
                    .insert(new Element("label", { "for": "imgeditor_width" })
                        .insert("Width:")
                ))
                .insert(new Element("td")
                    .insert(new Element("input", {
                        "name": "width",
                        "id": "imgeditor_width",
                        "size": "4",
                        "readonly": "readonly"
                    }))
                )
                .insert(new Element("td")
                    .insert(Foundation.Image.Editor.Button("Revert", this.revert.bind(this)))
                )
                .insert(new Element("td")
                    .insert(Foundation.Image.Editor.Button("Remove", this.removeCrop.bind(this)))
                )
            )
            .insert(new Element("tr")
                .insert(new Element("td")
                    .insert(new Element("label", { "for": "imgeditor_y1" })
                        .insert("Y:")
                ))
                .insert(new Element("td")
                    .insert(new Element("input", {
                        "type": "text",
                        "name": "y1",
                        "id": "imgeditor_y1",
                        "size": "4",
                        "readonly": "readonly"
                    })
                ))
                .insert(new Element("td")
                    .insert(new Element("label", { "for": "imgeditor_height" })
                        .insert("Height:")
                ))
                .insert(new Element("td")
                    .insert(new Element("input", {
                        "name": "height",
                        "id": "imgeditor_height",
                        "size": "4",
                        "readonly": "readonly"
                    }))
                )
                .insert(new Element("td")
                    .insert(Foundation.Image.Editor.Button("Cancel", this.cancel.bind(this)))
                )
                .insert(new Element("td")
                    .insert(Foundation.Image.Editor.Button("Save", this.save.bind(this)))
                )
            )
        );
    this.editorView.insert(form);

    this.setupCropper(true);
};

/**
 * @private
 * @param {boolean} useOrigCoords
 */
Foundation.Image.Editor.prototype.setupCropper = function (useOrigCoords) {
    var ratio = { x: 0, y: 0 };
    if (this.constraints.type == "fixed") {
        ratio.x = this.constraints.width;
        ratio.y = this.constraints.height;
    }

    var coords = useOrigCoords && this.origCoords ?
                 this.realCoordsToEditCoords(this.origCoords) :
                 null;

    this.cropper = new Cropper.Img(this.editImg, {
        "onloadCoords": coords,
        "displayOnInit": coords ? true : false,
        "ratioDim": ratio,
        "onEndCrop": this.updateCropCoords.bind(this),
        "autoIncludeCSS": false
    });

    this.updateCropCoords(coords || {});
    this.hasChanged = false;  // Reset hasChanged boolean.
};

/**
 * @private {{x1:number, y1:number, x2:number, y2:number}} coords
 */
Foundation.Image.Editor.prototype.updateCropCoords = function (coords) {
    coords = this.editCoordsToRealCoords(coords);

    var dimensions = {};
    if (coords["x2"] || coords["y2"]) {
        dimensions = {
            "width": coords["x2"] - coords["x1"],
            "height": coords["y2"] - coords["y1"]
        };
    }

    $("imgeditor_x1").value = coords["x1"] || "0";
    $("imgeditor_y1").value = coords["y1"] || "0";
    $("imgeditor_x2").value = coords["x2"] || "0";
    $("imgeditor_y2").value = coords["y2"] || "0";
    $("imgeditor_width").value = dimensions.width || "0";
    $("imgeditor_height").value = dimensions.height || "0";

    this.updateWarnings(dimensions);
    this.hasChanged = true;
};

/**
 * @private
 * @param {({width:number, height:number}|Object)} dimensions
 */
Foundation.Image.Editor.prototype.updateWarnings = function (dimensions) {
    if (this.constraints.type == "unknown") return;

    var constraintDim;
    if (this.constraints.type.match(/^(fixed|max|min)$/)) {
        constraintDim = dimensions.width <= dimensions.height ? "width" : "height";
        if (this.constraints.type == "min") {
            constraintDim = constraintDim == "width" ? "height" : "width";
        }
    }
    else if (this.constraints.width) {
        constraintDim = "width"
    }
    else {
        constraintDim = "height";
    }

    var oldWarning = this.warning.innerText || "";
    if ( dimensions[constraintDim] &&
         dimensions[constraintDim] < this.constraints[constraintDim] ) {
        this.warning.update(`Warning: ${constraintDim}s less than ${this.constraints[constraintDim]} will cause upscaling.`);
    }
    else {
        this.warning.update();
    }

    var newWarning = this.warning.innerText || "";
    if (oldWarning.length == 0 && newWarning.length > 0) {
        new Effect.Morph(this.editorChrome, {
            "style": { "backgroundColor": "#C15049" },
            "duration": 0.5
        });
    }
    else if (oldWarning.length > 0 && newWarning == 0) {
        new Effect.Morph(this.editorChrome, {
            "style": { "backgroundColor": this.chromeColor },
            "duration": 0.5
        });
    }
};

/**
 * @private
 * @param {{x1:number, y1:number, x2:number, y2:number}} c
 * @return {{x1:number, y1:number, x2:number, y2:number}}
 */
Foundation.Image.Editor.prototype.realCoordsToEditCoords = function (c) {
    return {
        "x1": this.ratioSolve(c["x1"], this.width, this.editImgDim.width),
        "y1": this.ratioSolve(c["y1"], this.height, this.editImgDim.height),
        "x2": this.ratioSolve(c["x2"], this.width, this.editImgDim.width),
        "y2": this.ratioSolve(c["y2"], this.height, this.editImgDim.height)
    };
};

/**
 * @private
 * @param {{x1:number, y1:number, x2:number, y2:number}} c
 * @return {{x1:number, y1:number, x2:number, y2:number}}
 */
Foundation.Image.Editor.prototype.editCoordsToRealCoords = function (c) {
    return {
        "x1": this.ratioSolve(c["x1"], this.editImgDim.width, this.width),
        "y1": this.ratioSolve(c["y1"], this.editImgDim.height, this.height),
        "x2": this.ratioSolve(c["x2"], this.editImgDim.width, this.width),
        "y2": this.ratioSolve(c["y2"], this.editImgDim.height, this.height)
    };
};

/**
 * @private
 * @param {number} a
 * @param {number} aT
 * @param {number} bT
 */
Foundation.Image.Editor.prototype.ratioSolve = function (a, aT, bT) {
    return (a < aT / 2 ? Math.floor : Math.ceil)(a * bT / aT);
};

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.revert = function () {
    this.cropper.remove();
    this.setupCropper(true);
};

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.removeCrop = function () {
    this.cropper.remove();
    this.setupCropper(false);
};

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.save = function (e) {
    if (e) e.stop();
    this.spinner = new Foundation.View.Spinner(this.editorView, { "delay": 1 });
    this.editorView.down("form").request({
        "onSuccess": this.finishedSaveRequest.bind(this),
        "onFailure": this.saveFailed.bind(this),
        "onException": this.endModal.bind(this)
    });
};

/**
 * @private
 * @param {Ajax.Response} transport
 */
Foundation.Image.Editor.prototype.finishedSaveRequest = function (transport) {
    var r = transport.responseJSON;
    if (r["status"] == "success") {
        this.image = new Foundation.Image(r["newSrc"]);
        this.image.setDimensions(r["newWidth"], r["newHeight"]);
        this.finished().fulfill();
    }
    else {
        window.alert(`Save failed: ${r["msg"].replace(/\s+/g, " ")}`);
    }

    this.endModal();
};

/**
 * @private
 * @param {Ajax.Response} transport
 */
Foundation.Image.Editor.prototype.saveFailed = function (transport) {
    var r = transport.responseJSON;
    if (r && r["errors"]) {
        window.alert(`Save failed:\n${r["errors"].join("\n")}`);
    }
    else {
        window.alert(`Save failed. Got ${transport.status} from server.`);
    }

    this.endModal();
}

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.cancel = function () {
    var msg = "Exit image editor without saving changes?";
    if (!this.changed() || window.confirm(msg)) {
        this.endModal();
    }
};

/**
 * @private
 * @return {boolean}
 */
Foundation.Image.Editor.prototype.changed = function () {
    if (!$("imgeditor_x1")) return false;
    if (!this.hasChanged) return false;

    var x1 = parseInt($F("imgeditor_x1"), 10);
    var y1 = parseInt($F("imgeditor_y1"), 10);
    var x2 = parseInt($F("imgeditor_x2"), 10);
    var y2 = parseInt($F("imgeditor_y2"), 10);
    var o = this.origCoords || { "x1": 0, "y1": 0, "x2": 0, "y2": 0 };
    return x1 != o["x1"] || y1 != o["y1"] || x2 != o["x2"] || y2 != o["y2"];
};

/**
 * @private
 * @param {string} text
 * @param {function(Event=)} action
 * @return {Element}
 */
Foundation.Image.Editor.Button = function (text, action) {
    return new Element("div")
        .update(text)
        .addClassName("imgeditor_button")
        .observe("click", function (e) {
            e.stop();
            action();
        })
        .observe("mousedown", /** @this {Element} */ function (e) {
            e.stop();
            this.addClassName("imgeditor_button_depressed");
        })
        .observe("mouseup", /** @this {Element} */ function (e) {
            e.stop();
            this.removeClassName("imgeditor_button_depressed");
        })
        .observe("mouseout", /** @this {Element} */ function (e) {
            e.stop();
            this.removeClassName("imgeditor_button_depressed");
        });
};

Foundation.Image.Editor.setupEditButtons = function () {
    Foundation.documentReady.then(function () {
        jQuery('img[src*="/imager/"],img[data-src*="/imager/"]').each(function () {
            var imgObj = jQuery(this);
            var imgSrc = imgObj.attr('src') || imgObj.attr('data-src')

            if (typeof imgSrc === 'undefined' || imgSrc.match(/\/original\//)) return;
            if (imgObj.closest('.no-foundation-imgeditor, li.memberItem').length) return;
            if (imgObj.hasClass('has-imgeditor-button')) return;

            imgObj.addClass('has-imgeditor-button')

            // uikit lazyloading stashes the original path in the data-src attribute
            // and replaces source with an inline svg value
            if (imgSrc.match(/data:image\/svg\+xml/)) {
                imgSrc = imgObj.attr('data-src')
            }

            var editButton = jQuery('<button>')
                .text('Edit')
                .css({ 'display': 'none', 'position': 'absolute' })
                .addClass("imgeditor_button")
                .click(function (e) {
                    e.preventDefault()
                    editButtonObj.removeClass('imgeditor_button_depressed').hide()
                    new Foundation.Image.Editor(imgSrc, function (fdnImgObj) {
                        var spinner = new Foundation.View.Spinner(imgObj, {
                            "width": 45,
                            "height": 45,
                            "borderRadius": 12,
                            "delay": 0
                        })

                        var imageLoadedCleanup = function () {
                            spinner.hide()
                            imgObj.off('load', imageLoadedCleanup)
                        }

                        imgObj
                            .on('load', imageLoadedCleanup)
                            .attr('src', fdnImgObj.url())
                            .attr('srcset', '')
                            .width(imgObj.width())
                            .css('height', 'auto')
                    })
                })
                .on('mousedown', function (e) { 
                    e.preventDefault()
                    jQuery(this).addClass('imgeditor_button_depressed')
                })
                .on('mouseup', function (e) { 
                    e.preventDefault()
                    jQuery(this).removeClass('imgeditor_button_depressed')
                })

            var editButtonObj = editButton.appendTo(jQuery('body'))

            var highestZ = 1
            imgObj.parentsUntil('html').each(function () { 
                var currentZ = parseInt(jQuery(this).css('z-index'))
                if (currentZ) {
                  highestZ = Math.max(highestZ, currentZ + 1)
                }
            })

            var stickButtonToImg = function () {
                editButtonObj.css({
                    'z-index': highestZ,
                    'top': `${imgObj.offset().top + 3}px`,
                    'left': `${imgObj.offset().left + 3}px`,
                })
            }

            imgObj.closest('div, a, li, button').hover( function () {
                editButtonObj
                    .show()
            }, function (e) {
                if ((e.relatedTarget || e.toElement) != editButtonObj[0]) {
                    editButtonObj.removeClass('imgeditor_button_depressed').hide()
                }
            })

            imgObj.closest('div, a, li').on('mouseover', stickButtonToImg)
            jQuery(window).on('resize scroll', stickButtonToImg)
        });
    });
};

// ---------------------------------------------------------------------

window["Foundation"]["Image"]["Editor"] = Foundation.Image.Editor;
Foundation.Image.Editor.prototype["finished"] = Foundation.Image.Editor.prototype.finished;

// Backwards compatibility.
window["Foundation"]["ImgEditor"] = Foundation.Image.Editor;
window["Foundation"]["ImgEditor"]["setupEditButtons"] = Foundation.Image.Editor.setupEditButtons;

// ---------------------------------------------------------------------

/* eslint eqeqeq: "off" */
